<div id="fullscreen-loader" *ngIf="!inlineLoader">
  <div class="align-absolute-center">
    <div class="lottie-player">
      <lottie-player src="/assets/lottieFiles/loader.json" background="transparent" speed="1" loop autoplay>
      </lottie-player>
    </div>
  </div>
</div>

<div class="inline-loader" *ngIf="inlineLoader">
  <div class="lottie-player">
    <lottie-player src="/assets/lottieFiles/loader.json" background="transparent" speed="1" loop autoplay>
    </lottie-player>
  </div>
</div>
